import { ResizeObserver } from "@juggle/resize-observer";
import { useEffect, useMemo, useState } from "react";
import { debounce } from "./../util/debounce";
import { runningInBrowser } from "~/const/browser";

type UseResizeWindowProps = {
  /** スクロールバーの幅を返り値に含めるか否かを判定 */
  shouldIncludedScrollBarWidth: boolean;
  debounceTime?: number;
};

export const useResizeWindow = ({ shouldIncludedScrollBarWidth, debounceTime = 500 }: UseResizeWindowProps) => {
  const [windowWidth, setWindowWidth] = useState(runningInBrowser ? window.innerWidth : 0);
  const [windowHeight, setWindowHeight] = useState(runningInBrowser ? window.innerHeight : 0);

  // MEMO: 画面リサイズの監視は500msに一度だけ行う
  const resizeObserver = useMemo(() => {
    return runningInBrowser
      ? new ResizeObserver(
          debounce((entries) => {
            entries.forEach((entry) => {
              const width = shouldIncludedScrollBarWidth ? window.innerWidth : entry.contentRect.width;
              setWindowWidth(width);
              setWindowHeight(window.innerHeight);
            });
          }, debounceTime)
        )
      : undefined;
  }, [shouldIncludedScrollBarWidth]);

  useEffect(() => {
    if (!resizeObserver) return;
    resizeObserver.observe(document.documentElement);
    return () => {
      resizeObserver.disconnect();
    };
  }, [resizeObserver]);

  return {
    windowWidth,
    windowHeight,
  };
};
